import { WebsiteWithConnections } from '../../types/website';
import { Button, Card } from '../ui';

interface QuickActionsPanelProps {
  website: WebsiteWithConnections | null;
  onAddLink: () => void;
  onDelete: () => void;
}

export default function QuickActionsPanel({ website, onAddLink, onDelete }: QuickActionsPanelProps) {
  return (
    <Card eyebrow="Quick Actions">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <a
          href={website?.url.match(/^https?:\/\//) ? website.url : `https://${website?.url}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'flex', textDecoration: 'none' }}
        >
          <Button iconTrailing="arrow-up-right" nudge data-dir="up" style={{ width: '100%' }}>
            Visit Site
          </Button>
        </a>

        <Button variant="secondary" icon="link" onClick={onAddLink} style={{ width: '100%' }}>
          Add Connection
        </Button>

        {website?.search_console_access && (
          <a
            href="https://search.google.com/search-console"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'flex', textDecoration: 'none' }}
          >
            <Button variant="secondary" icon="search" style={{ width: '100%' }}>
              Search Console
            </Button>
          </a>
        )}

        <Button variant="danger" icon="trash-2" onClick={onDelete} style={{ width: '100%' }}>
          Delete Website
        </Button>
      </div>
    </Card>
  );
}
